import { __ } from '@wordpress/i18n';
require('dom-slider');

const { slideToggle } = window.domSlider;

document.querySelectorAll('.block-card-services').forEach((block) => {
	const showButton = block.querySelector('.block-card-services__show-button');
	const showMoreGridContent = block.querySelector(
		'.block-card-services__show-more--content'
	);

	if (!showButton || !showMoreGridContent) return;

	const showMoreGrid = block.querySelector('.block-card-services__grid');

	showButton.addEventListener('click', (e) => {
		e.preventDefault();

		showButton.setAttribute('disabled', true);
		showMoreGridContent.classList.remove('block-content--hidden');

		const isOpening = !showMoreGridContent.classList.contains('active');

		if (isOpening) {
			showMoreGridContent.classList.add('active');
			showButton.setAttribute('aria-expanded', 'true');
			showButton.textContent = __('Show Fewer Services', 'propel');
			showMoreGrid.classList.add('is-open');
		} else {
			showMoreGridContent.classList.remove('active');
			showButton.setAttribute('aria-expanded', 'false');
			showButton.textContent = __('Show More Services', 'propel');
			showMoreGrid.classList.remove('is-open');
		}

		slideToggle({
			element: showMoreGridContent,
			slideSpeed: 400,
			easing: 'ease-in-out',
		}).then((el) => {
			if (el.classList.contains('DOM-slider-hidden')) {
				el.classList.add('block-content--hidden');
			}
			showButton.removeAttribute('disabled');
		});
	});
});
